import { Injectable } from "@angular/core";
import { CanActivate, CanActivateChild } from "@angular/router";
import { Router } from "@angular/router";
import { SessionTimeoutService } from "../../../services";

@Injectable()
export class CreateTestOrderGuard implements CanActivate, CanActivateChild {
  constructor(
    private router: Router,
    private sessionTimeoutService: SessionTimeoutService
  ) {}

  canActivate() {
    let user = JSON.parse(sessionStorage.getItem("User"));
    if (user.Role === "physician") {
      return true;
    }

    this.router.navigate(["/no-access"]);
    return false;
  }

  canActivateChild() {
    return this.canActivate();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/guard/physician-portal/route-guards/create-test-order.guard.ts